// src/routes/AppRoutes.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../constants/roles';
import ProtectedRoute from '../components/ProtectedRoute';
import MasterLayout from '../masterLayout/MasterLayout';
import Unauthorized from '../pages/Unauthorized';
import SignInPage from '../pages/SignInPage';
import ForgotPaaswordPage from '../pages/ForgotPasswordPage'
import Dashboard from '../pages/Dashboard/Dashboard';
import AdminDashboard from '../pages/AdminDashboard/AdminDashboard';
import ViewProfile from '../pages/Profile/ViewProfile';
// Farmer Management
import ViewFarmers from '../pages/ViewFarmers/ViewFarmers';
import AddFarmer from '../pages/Farmer/AddFarmer';

// Dealer Management
import ViewDealers from '../pages/Dealer/ViewDealers';
import AddDealer from '../pages/Dealer/AddDealers';

// Employee Management
import ViewEmployees from '../pages/Employee/ViewEmployees';
import AddEmployee from '../pages/Employee/AddEmployees';
import employeeRoutes from './modules/employeeRoutes';
// Company Management
import ViewCompanies from '../pages/Company/ViewCompanies';
import AddCompany from '../pages/Company/AddCompany';
import CompanyReport from '../pages/Company/CompanyReport';

// Product Management
import ViewProducts from '../pages/Product/ViewProducts';
import AddProduct from '../pages/Product/AddProduct';
import AddCategory from '../pages/Category/AddCategory';
import ViewProductDetail from '../pages/Product/ViewProductDetail';
import EditProduct from '../pages/Product/EditProduct';

// Region and Headquqrter management
import AddRegion from '../pages/Region/AddRegion';
import ViewRegions from '../pages/Region/ViewRegions';
import AddHeadquarter from '../pages/Headquarter/AddHeadquarter';
import ViewHeadquarters from '../pages/Headquarter/ViewHeadquarters';
import ChangeHeadquarter from '../pages/Headquarter/ChangeHeadquarter';
import AddSubHeadquarter from '../pages/SubHeadquarter/AddSubHeadquarter';
import ViewSubHeadquarters from '../pages/SubHeadquarter/ViewSubHeadquarters';
import ViewRegionDetail from '../pages/Region/ViewRegionDetail';
import EditRegion from '../pages/Region/EditRegion';

import ViewGodowns from '../pages/Godown/ViewGodowns';
import AddGodown from '../pages/Godown/AddGodown';

import ViewZonalManagers from '../pages/Team/ViewZonalManagers';
import ViewAreaManagers from '../pages/Team/ViewAreaManagers';
import ViewExecutives from '../pages/Team/ViewExecutives';
import ViewSalesOfficers from '../pages/Team/ViewSalesOfficers';
import ViewFieldAgents from '../pages/Team/ViewFieldAgents';

import GodownManagerDashboard from '../pages/Godown/GodownManagerDashboard';

import TourStatementsCompanySelection from '../pages/TourStatements/TourStatementsCompanySelection';
import TourStatementsEmployeeList from '../pages/TourStatements/TourStatementsEmployeeList';
import TourStatementsView from '../pages/TourStatements/TourStatementsView';

import TodayTours from '../pages/Reports/TodayTours';
import JointTours from '../pages/Reports/JointTours';
import AdvanceTours from '../pages/Reports/AdvanceTours';
import OrdersReport from '../pages/Reports/OrdersReport';

import StartKm from '../pages/Tour/StartKm';
import EndKm from '../pages/Tour/EndKm';
import MonthlyTours from '../pages/Tour/MonthlyTours';

import DealerVisit from '../pages/Tour/DealerVisit';

// Add imports at top (if not already there)
import VillagesList from '../pages/Farmer/VillagesList';
import FarmersByVillage from '../pages/Farmer/FarmersByVillage';
import FarmerVisitForm from '../pages/Farmer/FarmerVisitForm';
import FollowupList from '../pages/Farmer/FollowupList';

import CreateOrder from '../pages/Orders/CreateOrder';
import ExecutiveOrders from '../pages/Orders/ExecutiveOrders';
import farmerRoutes from './modules/farmerRoutes';
import DealerRoutes from './modules/dealerRoutes';
import SubDealerRoutes from './modules/subDealerRoutes';
import OrderDetail from '../pages/Orders/OrderDetail';
import godownRoutes from './modules/godownRoutes';

import TeamTours from '../pages/Tour/TeamTours';
import ViewDealerVisits from '../pages/Dealer/ViewDealerVisits';

import PaymentsPage from '../pages/Orders/PaymentsPage';

import ChatPage from '../pages/communication/ChatPage';

import FieldVisitsReport from '../pages/Reports/FieldVisitsReport';
import AddVillage from '../pages/Village/AddVillage';
import ViewVillages from '../pages/Village/ViewVillages';

import ViewHeadquarter from '../pages/Headquarter/ViewHeadquarter';
import EditHeadquarter from '../pages/Headquarter/EditHeadquarter';
import EditSubHeadquarter from '../pages/SubHeadquarter/EditSubHeadquarter';
import ViewsSubheadquarter from '../pages/SubHeadquarter/ViewsSubheadquarter ';
import CompanyDetailDashboard from '../pages/Company/CompanyDetailDashboard';
import ViewStatement from '../components/Statement/ViewStatement';
import StatementTable from '../components/Statement/StatementTable';

import EmployeeStatements from '../pages/Statements/EmployeeStatements';
import EmployeeStatementProfile from '../pages/Statements/EmployeeStatementProfile';
import StatementDetails from '../pages/Statements/StatementDetails'
import ViewAccountsEmployees from '../pages/Team/ViewAccountsEmployees';

const PAYMENT_ROLES = [
  ROLES.SALES_OFFICER, ROLES.EXECUTIVE, ROLES.AREA_MANAGER,
  ROLES.ZONAL_MANAGER, ROLES.ADMIN, ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN,
  ROLES.ACCOUNTS,
];


const PlaceholderPage = ({ title }) => (
  <div className="card">
    <div className="card-body">
      <h4>{title}</h4>
      <p className="text-muted">This page is under development.</p>
    </div>
  </div>
);

// Role groups for easy reference
const ALL_ROLES = Object.values(ROLES);
const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN];
const MANAGEMENT_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER];
const ORDER_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER];
const GODOWN_ROLES = [ROLES.GODOWN];

const FARMER_ROLES = [ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER, ROLES.FIELD_AGENT];
const DEALER_ROLES = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.SALES_OFFICER, ROLES.EXECUTIVE, ROLES.OFFICE_ADMIN, ROLES.FIELD_AGENT];
const DEALER_VISIT_VIEW_ROLES = [
  ROLES.SUPER_ADMIN,
  ROLES.OFFICE_ADMIN,
  ROLES.ADMIN,
  ROLES.ZONAL_MANAGER,
  ROLES.AREA_MANAGER,
  ROLES.EXECUTIVE,
  ROLES.SALES_OFFICER,   // ✅ SO and all above can view
];
const TOUR_FIELD_ROLES = [
  ROLES.ADMIN, ROLES.SUPER_ADMIN,
  ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER,
  ROLES.EXECUTIVE, ROLES.SALES_OFFICER,
  ROLES.FIELD_AGENT,
];





const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard/overview" replace /> : <SignInPage />} />
      <Route
        path="/forgot-password"
        element={isAuthenticated ? <Navigate to="/dashboard/overview" replace /> : <ForgotPaaswordPage />}
      />
      <Route path="/unauthorized" element={<Unauthorized />} />



      <Route
        path="/"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <Navigate to="/dashboard/overview" replace />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/view-profile"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <ViewProfile />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Dashboard Routes */}
      <Route
        path="/dashboard/overview"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <Dashboard />
            </MasterLayout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/company/:companyId/dashboard"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN]}>
            <MasterLayout>
              <AdminDashboard />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/reports"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Dashboard Reports" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/analytics"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Dashboard Analytics" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Set Target Routes */}
      <Route
        path="/target/zonal"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Target to Zonal" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Farmer Management Routes */}
      {farmerRoutes}
      <Route
        path="/farmer/add"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout>
              <AddFarmer />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/farmer/view"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout>
              <ViewFarmers />
            </MasterLayout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/farmer/first-visit"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout><VillagesList /></MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/farmer/first-visit/village/:village"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout><FarmersByVillage /></MasterLayout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/farmer/farmer-visit"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout><FollowupList /></MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/farmer/farmer-visit/village/:village/farmer/:farmerId"
        element={
          <ProtectedRoute allowedRoles={FARMER_ROLES}>
            <MasterLayout><FarmerVisitForm /></MasterLayout>
          </ProtectedRoute>
        }
      />


      {/* Dealer Management Routes */}
      {DealerRoutes}
      <Route
        path="/dealer/add"
        element={
          <ProtectedRoute allowedRoles={DEALER_ROLES}>
            <MasterLayout>
              <AddDealer />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dealer/visits"
        element={
          <ProtectedRoute allowedRoles={DEALER_VISIT_VIEW_ROLES}>
            <MasterLayout><ViewDealerVisits /></MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/dealer/view"
        element={
          <ProtectedRoute allowedRoles={DEALER_ROLES}>
            <MasterLayout>
              <ViewDealers />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {SubDealerRoutes}


      {/* Employee Management Routes */}
      {employeeRoutes}
      <Route
        path="/employee/add"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]}>
            <MasterLayout>
              <AddEmployee />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/employee/view"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <ViewEmployees />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Company Management Routes */}
      <Route
        path="/company/add"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN]}>
            <MasterLayout>
              <AddCompany />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/company/view"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN]}>
            <MasterLayout>
              <ViewCompanies />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/company/report"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <CompanyReport title="Company Reports" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/company-report/:id"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <CompanyDetailDashboard title="Company Reports View" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route path="/statements/employees" element={
        <ProtectedRoute allowedRoles={ADMIN_ROLES}>
          <MasterLayout><EmployeeStatements /></MasterLayout></ProtectedRoute>
      } />

      <Route path="/statements/employee/:userId" element={
        <ProtectedRoute allowedRoles={ADMIN_ROLES}>
          <MasterLayout><EmployeeStatementProfile /></MasterLayout>
        </ProtectedRoute>
      } />

      <Route path="/statements/employee/:userId/details" element={
        <ProtectedRoute allowedRoles={ADMIN_ROLES}>
          <MasterLayout><StatementDetails /></MasterLayout>
        </ProtectedRoute>
      } />

      {/* Product Management Routes */}
      <Route
        path="/product/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddProduct />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/product/view"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewProducts />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/product/category/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddCategory />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/product/view/:id"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewProductDetail />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/product/edit/:id"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <EditProduct />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Region Management Routes */}
      <Route
        path="/region/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddRegion title="Add Region" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />



      <Route
        path="/region/view"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewRegions title="View Regions" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route path="/region/view/:id"
        element={<ProtectedRoute allowedRoles={MANAGEMENT_ROLES}><MasterLayout><ViewRegionDetail /></MasterLayout></ProtectedRoute>} />

      <Route path="/region/edit/:id"
        element={<ProtectedRoute allowedRoles={ADMIN_ROLES}><MasterLayout><EditRegion /></MasterLayout></ProtectedRoute>} />

      <Route
        path="/headquarter/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddHeadquarter title="Add Headquarter" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/headquarter/view"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewHeadquarters title="View Headquarters" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route path="/headquarter/view/:id" element={
        <MasterLayout>
          <ViewHeadquarter title="View Headquarter" />
        </MasterLayout>
      } />
      <Route path="/headquarter/edit/:id" element={
        <MasterLayout>
          <EditHeadquarter title="Edit Headquarter" />
        </MasterLayout>
      } />

      <Route
        path="/headquarter/change"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <ChangeHeadquarter title="Change Headquarter" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/subhq/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddSubHeadquarter title="Add Sub-Headquarter" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/subhq/view"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewSubHeadquarters title="View Sub-Headquarters" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/subhq/view/:id"
        element={
          <ProtectedRoute allowedRoles={MANAGEMENT_ROLES}>
            <MasterLayout>
              <ViewsSubheadquarter title="Views Sub-Headquarters" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route path="/subhq/edit/:id" element={
        <MasterLayout>
          <EditSubHeadquarter title="Edit Sub Headquarter" />
        </MasterLayout>
      } />
      <Route
        path="/subhq/change"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Change SubHQ" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Village Management Routes */}
      <Route
        path="/village/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddVillage title="Add Village" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      {/* Village Management Routes */}
      <Route
        path="/villages/list"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <ViewVillages title=" Villages List" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/region/statement/upload"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Upload Statement" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/region/statement/delete"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Delete Statement" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Godown Management Routes */}
      {godownRoutes}
      <Route
        path="/godown/add"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <AddGodown title="Add Godown" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/godown/view"
        element={
          <ProtectedRoute allowedRoles={[...MANAGEMENT_ROLES, ROLES.GODOWN]}>
            <MasterLayout>
              <ViewGodowns title="View Godowns" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />


      {/* Team View Routes */}
      <Route
        path="/team/zonal-managers"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <ViewZonalManagers title="View Zonal Managers" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/area-managers"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER]}>
            <MasterLayout>
              <ViewAreaManagers title="View Area Managers" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/executives"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER]}>
            <MasterLayout>
              <ViewExecutives title="View Executives" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/sales-officers"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE]}>
            <MasterLayout>
              <ViewSalesOfficers title="View Sales Officers" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/field-agents"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.EXECUTIVE, ROLES.SALES_OFFICER]}>
            <MasterLayout>
              <ViewFieldAgents title="View Field Agents" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/accounts-employees"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <ViewAccountsEmployees title="View Accounts Employees" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Tour Management Routes */}
      <Route
        path="/orders/godown-dashboard"
        element={
          <ProtectedRoute allowedRoles={[...MANAGEMENT_ROLES, ROLES.GODOWN]}>
            <MasterLayout>
              <GodownManagerDashboard title="Godown Dashboard" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders/tour-statements"
        element={
          <ProtectedRoute allowedRoles={ORDER_ROLES}>
            <MasterLayout>
              <TourStatementsCompanySelection title="View Tour Statements" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/orders/tour-statements/employees/:companyId"
        element={
          <ProtectedRoute allowedRoles={ORDER_ROLES}>
            <MasterLayout>
              <TourStatementsEmployeeList title="View Tour Employee Statements" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders/tour-statements/view/:userId"
        element={
          <ProtectedRoute allowedRoles={ORDER_ROLES}>
            <MasterLayout>
              <TourStatementsView title="View Tour Statement Details" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tour/team-tours"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout><TeamTours /></MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders/document/upload"
        element={
          <ProtectedRoute allowedRoles={ORDER_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Upload Document" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders/document/delete"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Delete Document" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />


      <Route path="/view-details/:id"
        element={<ProtectedRoute allowedRoles={ORDER_ROLES}>
          <MasterLayout><ViewStatement /></MasterLayout>
        </ProtectedRoute>}
      />

      <Route path="/company/:companyId/statement"
        element={<ProtectedRoute allowedRoles={ORDER_ROLES}>
          <MasterLayout><StatementTable /></MasterLayout>
        </ProtectedRoute>}
      />
      <Route path="/orders/create"
        element={<ProtectedRoute allowedRoles={ORDER_ROLES}>
          <MasterLayout><CreateOrder /></MasterLayout>
        </ProtectedRoute>}
      />

      <Route path="/orders/my-orders"
        element={<ProtectedRoute allowedRoles={ORDER_ROLES}>
          <MasterLayout><ExecutiveOrders /></MasterLayout>
        </ProtectedRoute>}
      />

      <Route path="/orders/all"
        element={<ProtectedRoute allowedRoles={[ROLES.EXECUTIVE, ROLES.OFFICE_ADMIN, ROLES.SUPER_ADMIN, ROLES.ZONAL_MANAGER, ROLES.AREA_MANAGER, ROLES.GODOWN]}>
          <MasterLayout><ExecutiveOrders /></MasterLayout>
        </ProtectedRoute>}
      />

      <Route
        path="/orders/detail/:id"
        element={
          <ProtectedRoute allowedRoles={[
            ROLES.SALES_OFFICER,
            ROLES.EXECUTIVE,
            ROLES.ADMIN,
            ROLES.SUPER_ADMIN,
            ROLES.ZONAL_MANAGER,
            ROLES.AREA_MANAGER,
          ]}>
            <MasterLayout>
              <OrderDetail />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route path="/orders/payments"
        element={
          <ProtectedRoute allowedRoles={PAYMENT_ROLES}>
            <MasterLayout><PaymentsPage /></MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Reports Routes */}
      <Route
        path="/reports/todays-tours"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout>
              <TodayTours title="Today's Tours" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/joint-tours"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout>
              <JointTours title="Joint Tours" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/advance-tours"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout>
              <AdvanceTours title="Advance Tours" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/orders"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <OrdersReport title="Orders Report" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/sales"
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Sales Report" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports/field-visits"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.OFFICE_ADMIN, ROLES.ACCOUNTS]}>
            <MasterLayout>
              <FieldVisitsReport />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      { /* Tour Routes — Field Agent only */}

      <Route path="/tour/start-km"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout><StartKm /></MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route path="/tour/end-km"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout><EndKm /></MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/tour/dealer-visit"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout>
              <DealerVisit />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route path="/tour/monthly"
        element={
          <ProtectedRoute allowedRoles={TOUR_FIELD_ROLES}>
            <MasterLayout><MonthlyTours /></MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Communication Routes */}
      <Route
        path="/communication/chat"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <ChatPage />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/communication/announcements"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="Announcements" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Profile Routes */}
      <Route
        path="/profile/view"
        element={
          <ProtectedRoute allowedRoles={ALL_ROLES}>
            <MasterLayout>
              <PlaceholderPage title="View Profile" />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      {/* Catch all - 404 */}
      <Route
        path="*"
        element={
          <div className="min-vh-100 d-flex align-items-center justify-content-center">
            <div className="text-center">
              <h1 className="display-1 fw-bold text-muted">404</h1>
              <p className="lead">Page not found</p>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default AppRoutes;